module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "default",
    attrs: {
      "id": "d8e4100NaN"
    }
  }), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "d7e353635"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/Lodi_9781937084325_epub_toc_r1#d6e5",
      "id": "d7e5"
    }
  }, [_vm._v("Chapter 4 ")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e354135"
    }
  }, [_vm._v("H.S.H.S. was made up of many tall buildings that were spread out around a big opening in the forest. Everyone wore uniforms and walked at the same pace. The entire place was seriously silent. I hated it already, but I was fascinated by everyone’s different-colored hair. There were different shades of brown, blond, black, and even a sort of red, like fire. The eye color also differed. The colors mixed and matched in every combination possible. I no longer stood out like a sore thumb.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e357235"
    }
  }, [_vm._v("Matthew brought me to the principal’s office and introduced me as the “chosen one.” I didn’t know what that meant. He then said that I was tough, had an attitude, and needed to start training immediately. When I had started to speak, he slapped my cheek. My hate for him only blossomed. I saw the devil in him, and that was all he was: a demon.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e359335"
    }
  }, [_vm._v("The principal was a tall man with violet eyes and black hair. He had a small beard to compensate for his naked cranium. His thick eyebrows matched his dark voice. He limped from what I assumed was a war injury. Although he tried to make it clear that he was the intermediate between Matthew and I, Matthew argued that he was in charge. I found the fight for authority entertaining, but Matthew was superior to his pawn. He was a total control freak.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e361835"
    }
  }, [_vm._v("Matthew showed me around the campus. One building was made  up of dormitories, the cafeteria, and the school. There were gyms, a business building for those who helped rule our community, and two prisons. The word scared me: prisons. Why were there cells at the school? The school seemed like an army base. I felt trapped. Wherever I looked, I saw soldiers dressed in the same red, silver, and black attire with determined looks that reflected their authority and strength.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e364736"
    }
  }, [_vm._v("Matthew and the principal brought me to my dormitory. Matthew forcefully threw me onto the bed. Before closing the door, the principal spoke, “You may call me ‘sir,’ just like everyone else here. The bathrooms are in the room next door. The cafeteria is on the main floor as you saw earlier. Your classes start tomorrow at 0500 in Gym 1 on the third floor. You do not have any roommates or any friends here. You do as we say, or there will be consequences. Matthew will be keeping track of your progress, as will I. Although you know Matthew personally, you go through me. Any questions?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368036"
    }
  }, [_vm._v("“I don’t—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e368536"
    }
  }, [_vm._v("He slammed the door before I could finish my sentence. I ran to the door and tried to turn the handle—to push or pull it open, so that I could see light. But it was locked. I hated it. I hated everything. The truth was heavier than the lies.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e370036"
    }
  }, [_vm._v("My room was dark, so I ran my hands along the wall, looking for a light switch. I didn’t find any. I tried to feel my way around the place. A bed with olive green covers sat in the corner by a locked window, and there was a small closet on my right, but the rest of the room was empty. It was cold, small, and isolated.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e372036"
    }
  }, [_vm._v("I lay on my bed, trembling from exhaustion, confusion, and fear, shivering as tears uncontrollably ran down my cheeks. I couldn’t think straight. Everything I had known was a lie. I didn’t know what to believe because nothing seemed right. What was I doing here? Where exactly was here? I was lost. I was on my own. Exhausted, I curled on my bed, too uncomfortable to get under the covers. I closed my  eyes and cried myself to sleep, unable to hold it in any longer. I knew I wasn’t going to stay here very long. I wanted to go home, wherever that was, but the world seemed to be disintegrating, slipping through my fingers.")]), _vm._v(" "), _c('p', {
    staticClass: "ser"
  }, [_c('img', {
    staticClass: "imgpub",
    attrs: {
      "alt": "9781937084318-txt_0037_001",
      "id": "d14e745",
      "src": "images/9781937084318-txt_0037_001.jpg"
    }
  })]), _c('p', {
    staticClass: "tx1",
    attrs: {
      "id": "d7e376337"
    }
  }, [_vm._v("“Wake up call!” It was more of an order than anything else.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e377537"
    }
  }, [_vm._v("I slowly opened my eyes, and the blurry world became visible. A piercing light blinded me for a second. I figured it came on automatically, because I scanned the walls and still couldn’t find a switch. I thought everything was all a bad dream, but as I stared at the bare walls of my room—my cell—I realized that it was a reality. My head was spinning and my cheeks were still wet from tears. I was tired. My legs collapsed beneath me as I tried to get up. I leaned against the wall to keep myself from falling as I made my way to the closet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e380337"
    }
  }, [_vm._v("I found two pairs of pants and three shirts. They were all black with red stripes along the sides, and a silver “M” was embroidered on the left breast. I slipped them on as quickly as I could and ran downstairs. I was surprised to find the door opened, but I didn’t think twice before leaving. I wanted to escape.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e382137"
    }
  }, [_vm._v("Soldiers were everywhere and stood with authority. Every exit and entrance was blocked, while windows were nonexistent. There were over a thousand students walking down the stairs in a perfectly straight line, like sheep being shepherded by soldiers dressed in blood.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e383537"
    }
  }, [_vm._v("I felt as though everyone was staring at me, their gazes following my every move. The students started to whisper and point at me. I hated it. I felt like an animal in a zoo. Not only was I the center of attention, but I was the shortest and the youngest by at least eight years. My stomach felt like a rock. We made our way to the cafeteria. The smell of omelets infiltrated my head and made me realize that I was hungry. Every part of me wanted to eat. My stomach growled, and my legs moved faster.  The thought of food was all that swam in my mind. I hadn’t eaten dinner the night before. I stood in line for an omelet.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e387138"
    }
  }, [_vm._v("“That’s for the teachers only,” said a man behind me as he slapped my hand when I reached for a plate. He pointed to a line of students, then shoved me off in their direction. My breakfast was a fruit smoothie, which was terrible, and sausages. I drank the smoothie as quickly as I could, holding my breath as I swallowed. We were then hurried to go to class.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e389238"
    }
  }, [_vm._v("Battle Class was first. I learned how to fight. It wasn’t like the martial arts I had studied; it was more combative and aggressive. The teacher was tall and built, and his voice was powerful, which made me feel tiny and weak. He made us do over five hundred push-ups, but it felt like nothing because the S.S. Pill had kicked in.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e391038"
    }
  }, [_vm._v("The instructor had us do core work as well as running. Apparently, I was in an advanced class, so he picked on me a lot because I didn’t know how to stand when fighting, punching, kicking, blocking, or anything else. I was ignorant of everything, and I was sure he thought I was a moron.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e392938"
    }
  }, [_vm._v("“Alexia!” The instructor’s voice was sharp.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393438"
    }
  }, [_vm._v("“Sir!” I quickly responded.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e393938"
    }
  }, [_vm._v("“Step forward.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e394538"
    }
  }, [_vm._v("I did as I was told and then he called out a couple other students. He went over some sparring rules and then had us fight. I was first against another girl, Torin. She didn’t hesitate to attack first, and I was forced to lunge back to avoid a powerful kick. Her techniques were similar to Miles’s, but I quickly realized that she was defter at fighting. Her training had conditioned her marvelously. I was hardly ever given an opportunity to attack.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e397338"
    }
  }, [_vm._v("“Come on, Alexia! You can’t win if you only defend! Get your act together and strike back! You’re acting like this is your first time in  the ring. Do something! Anything would be better than this!” the instructor yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e399339"
    }
  }, [_vm._v("I took a few blows to the abdomen, then I started to put in more effort.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e400239"
    }
  }, [_vm._v("“When she goes for your head, step in, meet her entry with a front jab followed by a reverse uppercut. And if she blocks, be ready to send a hook off your front hand. These are only suggestions, Alexia. You should know how to take care of yourself. I shouldn’t have to help you out,” the instructor spat.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e402039"
    }
  }, [_vm._v("I struck Torin’s shoulder, took out her knee with a quick kick, then kneed her in the abdomen. She fell to her knees, and I backed away. I waited for her to get back up.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e403139"
    }
  }, [_vm._v("“If this were on the battlegrounds, you wouldn’t have survived, Alexia. You don’t wait and watch your opponent’s reaction or admire what you’ve done! You finish what you’ve started! Next time, you end when she doesn’t wake up, got it?” the instructor shouted. Then he stormed over to me and grabbed my arm. “What’s the problem? Are you afraid of hurting someone? You better get used to it. Besides, we have the medical center down the hallway, so stop being a wimp and take control of the fights!” He glared at me. “Do you understand?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e405939"
    }
  }, [_vm._v("“Yes, sir,” I answered timidly as I looked away.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e406439"
    }
  }, [_vm._v("By the end of the class, I knew enough to win a couple of short and quick one-on-one battles. I took many hits at first, unwilling to hurt anyone, but after receiving bruises and enough punishments from my teacher, I started to feel my muscles work. Sweat was natural, and everyone smelled. I wanted to shower, but I didn’t have the time.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e408239"
    }
  }, [_vm._v("H.S.H.S. was weirder than I had thought. The classes were all about war. I learned about the human body and how the army controlled the mentally impaired foot soldiers through specific phrases and actions. As far as I could tell, I was the only student without C.I. Pill damage  and could think for myself, while others simply followed protocol. I also learned how to treat all injuries as a form of precaution. I had to learn about other communities and their armies so we could conquer them.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e411440"
    }
  }, [_vm._v("In Strategy Class, one student answered most of the questions and received the instructor’s praise. His name was Zachary, and for whatever reason, he always picked on me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e412640"
    }
  }, [_vm._v("“Do I have permission to demonstrate the simple strategies with Alexia, sir?” Zachary asked in a sly voice.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e413540"
    }
  }, [_vm._v("“Granted.” The teacher stepped back to give us some space in the center of the room.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e414340"
    }
  }, [_vm._v("Zachary latched onto my arm and pulled me out of my seat. He then led me to the center of the room. He turned to face me, but before I could react he punched my jaw, then punched me in the abdomen. My arms lowered to protect where he had just hit me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e415840"
    }
  }, [_vm._v("“Hit high to force your opponent to protect everything high, then hit low,” Zachary explained with a thin, long smile.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e416740"
    }
  }, [_vm._v("“Very simple, yet very effective,” the instructor added.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e417240"
    }
  }, [_vm._v("Zachary was in all of my classes and would not leave me alone. He was a few years older than I with light, brown hair and green eyes. He wasn’t the typical bully, who might pull my hair and tease me whenever the teacher had his back turned. Instead, Zachary liked to ask for permission to challenge me, often physically. And to my surprise, permission was always granted. In Battle Class, Zachary was the one who showed the least mercy for new students, especially me. He would kick me and punch me even if we weren’t supposed to be fighting. And he would always turn to his friends afterward to remind them of how defenseless I was. He had kicked me in the face a couple of times, giving me a bloody nose and cutting my lip. I also had a few bruised ribs by the end of the day. Zachary had pushed me down the stairs as we were walking to our next class, and he dug his heel into  my hand. His insults dripped from his lips, filling me with hatred and discouragement. I thought someone, anyone, would notice, and they did, but nobody seemed to care. Instructors would simply compliment his good form and remind me of my weak defense. I wanted to pound on Zachary, at least once, just to show him that I could do something, that I wasn’t helpless, that I wasn’t his victim, but I refused to lose control. His standards were too low, and I couldn’t succumb to them. It would ruin me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e425041"
    }
  }, [_vm._v("As I walked to my next class, I started to listen to what the other students were saying.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e425941"
    }
  }, [_vm._v("“She’s the one who’s going to take his place?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e426441"
    }
  }, [_vm._v("“Just look at her . . . she’s clueless!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e426941"
    }
  }, [_vm._v("“Her?! Her scream will ring around the world when she goes to battle.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e427841"
    }
  }, [_vm._v("I cringed. What was I doing here? As I listened, I came to one conclusion: I was to kill without mercy as I led Matthew’s army to destroy other communities.“The chosen one.” That was my newest nickname. Matthew had picked me out of all the students at my old school, and I wasn’t even skilled like the students at H.S.H.S. I was just “chosen” to be his newest marionette soldier. I didn’t know what had appealed to him; maybe it was my aggressive personality. I didn’t like being isolated simply because of my new nickname, but what drove me crazy was that I didn’t even know what it really meant. I didn’t want to have anything to do with the War, and I most definitely did not want to be the “chosen one,” whatever that meant.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e431541"
    }
  }, [_vm._v("As soon as lunch rolled around, I went around the campus many times. I passed some prisoners, who sat in dark cells alone, hungry, and in pain. Tears burned my eyes as I tried to imagine what they were going through. After I had seen the prisoners of war, it all seemed pointless. I ran to the principal’s office as soldiers raced after me. I kicked the door open and demanded explanations. I wanted answers  and wasn’t going to leave until I was satisfied.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e434442"
    }
  }, [_vm._v("Two soldiers came up from behind and started to drag me out, but the principal called them off. He got up and paced, avoiding eye contact. “Only one community can live in this world, so we have to fight for that spot, and you will be leading us.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e435942"
    }
  }, [_vm._v("“You expect me to order our army to kill innocent people? Never!” I yelled.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e437042"
    }
  }, [_vm._v("“Yes, you will. We’ll be there supporting you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e437542"
    }
  }, [_vm._v("I refused to stay calm when others were dying because of the war I was being forced into.“No! Never! Someone else can be your joker!” I slammed my hand on his desk, and the tingling, stinging sensation burst up my arm.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e439242"
    }
  }, [_vm._v("“No one can take your place. You have been chosen to lead us and so you will. You are stronger than others and much more intelligent—”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e440142"
    }
  }, [_vm._v("“And I have a mind and heart. My heart will not let me kill, and my mind tells me to end this war by not starting it!”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e440942"
    }
  }, [_vm._v("“It already started.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e441442"
    }
  }, [_vm._v("“Then I refuse to continue it! I’m leaving.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e442042"
    }
  }, [_vm._v("“You can’t.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e442542"
    }
  }, [_vm._v("I turned around, ready to exit, but ran into Matthew in the doorway. He grabbed my arm tightly. “You’re staying.” His voice was calm but resonated with power and authority.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e443942"
    }
  }, [_vm._v("“No!” I twisted and turned, but couldn’t release his grip.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e444442"
    }
  }, [_vm._v("“I didn’t ask for your opinion. I told you that you’re staying, and that’s final.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e445342"
    }
  }, [_vm._v("“Why? Get someone else to do your dirty work. I don’t want blood on my hands.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e446242"
    }
  }, [_vm._v("“No one can replace you.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e446742"
    }
  }, [_vm._v("“Why not?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e447242"
    }
  }, [_vm._v("“You do not question authority.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e448343"
    }
  }, [_vm._v("“You said it yourself; I’m giving orders,” I mocked him.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e448843"
    }
  }, [_vm._v("“Not to me!” He twisted my arm, and I fell to my knees. “Let’s see what you’ve learned. Fight back!” he ordered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e449643"
    }
  }, [_vm._v("I quickly turned onto my back, forcing him to release my arm. He tried to punch me, but I kicked him. He attempted another kick, but I moved away. He was furious, and I took advantage of it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e450843"
    }
  }, [_vm._v("“You ‘ordered’ me to fight back,” I snapped.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e451443"
    }
  }, [_vm._v("He pushed me to the floor and held a gun against my temple. I could hardly breathe, and my heart was pounding out of my chest. His eyes glimmered with anger, but there was a flicker of delight hidden there. I could see my reflection in his eyes. I hated him, and the feeling was obviously mutual.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e453243"
    }
  }, [_vm._v("He handcuffed my wrists with electric locks and pulled me to my feet. He turned me around, our faces inches from each other.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e454043"
    }
  }, [_vm._v("“You do as I say, or you won’t be able to do anything at all, not even breathe. You’re my heir, so you train as I desire and you follow the plans I’ve mapped out.” His words slithered into my ears. His hands on my shoulders were like a snake’s fangs injecting venom.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e455543"
    }
  }, [_vm._v("“Why?” I managed to say, even though I trembled with fear.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e456043"
    }
  }, [_vm._v("“Because no one lives forever, and I need to know that my successor will finish what I’ve started.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e456943"
    }
  }, [_vm._v("“Why me?”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e457443"
    }
  }, [_vm._v("“Because you can get the job done! Because I chose you! You should be grateful! I’m offering you more than anyone else could ever have.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e458343"
    }
  }, [_vm._v("“But I never asked for it.”")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e458843"
    }
  }, [_vm._v("Another blow to the abdomen sparked shivers that ran down my spine as I started to fall to my knees. Matthew lifted me up again and turned me to face the door. He then ordered four soldiers to accompany me to my room. I wasn’t to eat dinner, but I had to attend an extra class until midnight.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e461144"
    }
  }, [_vm._v("I allowed them to take me back to my room, but I secretly vowed to not stay for long. I refused to remain locked up in a nightmare that was to end with death. I wanted Matthew’s life to end, for all he had done was take others’ lives mercilessly and without the slightest regret. I rejected being forced into becoming a killer, or worse: Matthew’s heir.")]), _vm._v(" "), _c('p', {
    staticClass: "tx",
    attrs: {
      "id": "d7e462944"
    }
  }, [_vm._v("I was going to run away.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3daba507","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Lodi_9781937084325_epub_c7_r1.vue
// module id = 78
// module chunks = 0